/* ============================================================
   VICIT LEO — product page behaviour
   1. Size gate: while <html data-vl-size-gate="on"> (set inline by
      snippets/vl-size-gate.liquid), every purchase path on the main
      product is held until a size is picked, and a click on one of them
      sends the shopper to the size picker instead.
   2. Size guide drawer: opens the native <dialog> rendered by
      blocks/vl-product-story.liquid.
   Plain script, no dependencies; listeners are delegated on document so
   they survive Horizon's morphing of the product section.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var PROMPT = 'Choose your size to continue.';
  var BUY_TARGETS = '.product-information .add-to-cart-button, .sticky-add-to-cart__button, .vl-gate-shield';

  function gated() {
    return root.dataset.vlSizeGate === 'on';
  }

  function sizeFieldset() {
    return document.querySelector('variant-picker[data-template-product-match="true"] [data-vl-size-option]');
  }

  /* ---------- size gate ---------- */

  function labelButtons() {
    document.querySelectorAll('.product-information .add-to-cart-button, .sticky-add-to-cart__button').forEach(function (button) {
      if (gated()) {
        button.setAttribute('aria-label', 'Select a size');
      } else if (button.getAttribute('aria-label') === 'Select a size') {
        button.removeAttribute('aria-label');
      }
    });
  }

  /* Shop Pay renders inside its own element, so a transparent button is laid
     over it while the gate is on. Clicking it prompts for a size. */
  function shieldExpressCheckout() {
    document.querySelectorAll('.product-information .accelerated-checkout-block').forEach(function (block) {
      if (block.querySelector('.vl-gate-shield')) return;
      var shield = document.createElement('button');
      shield.type = 'button';
      shield.className = 'vl-gate-shield';
      shield.setAttribute('aria-label', 'Select a size before express checkout');
      block.appendChild(shield);
    });
  }

  function prompt() {
    var fieldset = sizeFieldset();
    if (!fieldset) {
      release();
      return;
    }

    var message = fieldset.querySelector('.vl-size-prompt');
    if (!message) {
      message = document.createElement('p');
      message.className = 'vl-size-prompt';
      message.setAttribute('role', 'alert');
      fieldset.appendChild(message);
    }
    /* Re-set the text so a repeat click is announced again. */
    message.textContent = '';
    window.requestAnimationFrame(function () {
      message.textContent = PROMPT;
    });

    fieldset.removeAttribute('data-vl-attention');
    void fieldset.offsetWidth; /* restart the attention animation */
    fieldset.setAttribute('data-vl-attention', '');

    fieldset.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    var first = fieldset.querySelector('input[type="radio"]:not([aria-disabled="true"])') || fieldset.querySelector('input[type="radio"]');
    if (first) first.focus({ preventScroll: true });
  }

  function release() {
    if (!gated()) return;
    delete root.dataset.vlSizeGate;
    var fieldset = sizeFieldset();
    if (fieldset) {
      fieldset.removeAttribute('data-vl-attention');
      var message = fieldset.querySelector('.vl-size-prompt');
      if (message) message.remove();
    }
    labelButtons();
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!gated() || !(event.target instanceof Element)) return;
      if (!event.target.closest(BUY_TARGETS)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      prompt();
    },
    true
  );

  /* Enter in the quantity field submits the form without a click. */
  document.addEventListener(
    'submit',
    function (event) {
      if (!gated() || !(event.target instanceof Element)) return;
      if (!event.target.closest('.product-information')) return;
      if (!event.target.querySelector('input[name="id"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      prompt();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (event.target instanceof Element && event.target.closest('[data-vl-size-option]')) release();
    },
    true
  );

  /* ---------- size guide drawer ---------- */

  function sizeGuide() {
    return document.querySelector('dialog[data-vl-size-guide]');
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var dialog = sizeGuide();
    if (!dialog) return;

    if (event.target.closest('[data-vl-size-guide-open]')) {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      return;
    }
    if (event.target.closest('[data-vl-size-guide-close]')) {
      dialog.close();
      return;
    }
    /* A click on the backdrop lands on the dialog element itself. */
    if (event.target === dialog) dialog.close();
  });

  function init() {
    if (gated()) {
      labelButtons();
      shieldExpressCheckout();
    }
    /* The size guide link only makes sense when the drawer exists. */
    if (!sizeGuide()) {
      document.querySelectorAll('[data-vl-size-guide-open]').forEach(function (link) {
        link.hidden = true;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
